import React from 'react';
import { ChevronDown } from 'lucide-react';

/** Accessible "See assumptions" disclosure placed directly beneath a scenario. */
export function AssumptionsDisclosure({
  children
}: {
  children: React.ReactNode;
}) {
  return <details className="group mt-5 rounded-md border border-line" data-id="element-2530" data-mp="3kipn8ocgw4u1">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 px-4 py-3 text-sm font-semibold text-navy hover:bg-surface-bg rounded-md transition-colors duration-150 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal [&::-webkit-details-marker]:hidden" data-id="element-2531" data-mp="3fked0ci9fsba">
        See assumptions
        <ChevronDown size={16} aria-hidden="true" className="shrink-0 transition-transform duration-200 group-open:rotate-180" data-id="element-2532" data-mp="30txdiyp6rch1" />
      </summary>
      <div className="border-t border-line px-4 py-4" data-id="element-2533" data-mp="g47yolohfqoc">{children}</div>
    </details>;
}